import { ReactNode } from "react";

export type NestedKeyOf<T> =
  | (keyof T & string)
  | {
      [K in keyof T & string]: NonNullable<T[K]> extends object
        ? `${K}.${keyof NonNullable<T[K]> & string}`
        : never;
    }[keyof T & string];

export interface ColumnDef<T> {
  displayName: string;
  sortable: boolean;
  sortKey: string;
  alignRight: boolean;
  cell: (row: T) => ReactNode;
}

export function createColumnHelper<T extends { id: number }>() {
  return {
    accessor: (
      field: NestedKeyOf<T>,
      options: {
        displayName: string;
        sortable: boolean;
        sortKey?: string;
        alignRight: boolean;
        cell: (row: T) => ReactNode;
      }
    ): ColumnDef<T> => {
      return {
        displayName: options.displayName,
        sortable: options.sortable,
        sortKey: options.sortKey || (field as string),
        alignRight: options.alignRight,
        cell: options.cell,
      };
    },
  };
}
